import { render, staticRenderFns } from "./SpeakerProfile.vue?vue&type=template&id=fa710374&scoped=true&"
import script from "./SpeakerProfile.vue?vue&type=script&lang=ts&"
export * from "./SpeakerProfile.vue?vue&type=script&lang=ts&"
import style0 from "./SpeakerProfile.vue?vue&type=style&index=0&id=fa710374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa710374",
  null
  
)

export default component.exports